import { ChatPanelTabType } from './store/slice'

/** Pairs each chat panel tab with the element it controls, so assistive technology can follow the link. */
export const kChatPanelTabIds: Record<ChatPanelTabType, { tab: string; content: string }> = {
  [ChatPanelTabType.Assistant]: { tab: 'chat-panel-tab-assistant', content: 'chat-panel-tab-content-assistant' },
  [ChatPanelTabType.Source]: { tab: 'chat-panel-tab-source', content: 'chat-panel-tab-content-source' },
}
